/* eslint-disable @bigbinary/neeto/use-neetoui-classes */
import { forwardRef } from "react";

import { ChevronRight } from "lucide-react";

import ProfileHeader from "../ProfileHeader";

const MenuButton = forwardRef(({ profileInfo, ...otherProps }, ref) => (
  <button
    {...{ ref }}
    className="hover:bg-accent flex w-full items-center gap-2 rounded-md px-2.5 py-2 transition-colors"
    data-testid="profile-expand-menu-button"
    type="button"
    {...otherProps}
  >
    <ProfileHeader {...{ profileInfo }} />
    <ChevronRight className="shrink-0 rtl:scale-x-[-1]" size={18} />
  </button>
));

MenuButton.displayName = "ProfileExpandMenuButton";

export default MenuButton;
